"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const h = React.createElement;
const style = (0, nano_theme_1.drule)({
    trs: 'transform .3s',
    o: 0.7,
    path: {
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2px',
        strokeLinecap: 'round',
    },
});
const Arrow = ({ direction, size = 16, ...rest }) => {
    const css = {};
    if (direction !== 'u') {
        let deg = 90;
        switch (direction) {
            case 'd':
                deg = 180;
                break;
            case 'l':
                deg = 270;
                break;
        }
        css.transform = `rotate(${deg}deg)`;
    }
    const className = style(css);
    return h('svg', {
        width: size,
        height: size,
        ...rest,
        className: (rest.className ?? '') + className,
        viewBox: '0 0 32 32',
    }, h('path', { d: 'M10 18 L16 12 L22 18' }, h('animate', {
        attributeName: 'd',
        dur: '300ms',
    })));
};
exports.default = Arrow;
